import React, { useEffect, useState, Fragment } from 'react';
import { CheckCircle2, Compass, ShieldCheck, LayoutGrid, ArrowRight, Check, Lock, Star, X, Crown, Sparkles } from 'lucide-react';
const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/aESWUxoEzBHviRpfk5WwvS/mockup_adicciones.png';
const MOCKUP_UPSELL_URL = 'https://cdn.magicpatterns.com/uploads/wWAotK64qSQkzcnCrmiU7k/mockup_adicciones_(1).png';
const CHECKOUT_URL_BASE = 'https://checkout.sectordigital.online/cart/44115707822123:1';
const CHECKOUT_URL_PLUS = 'https://checkout.sectordigital.online/cart/44124181233707:1';
const scrollToPurchase = (e: React.MouseEvent) => {
  e.preventDefault();
  const countdown = document.getElementById('countdown-timer');
  if (countdown) {
    countdown.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
};
const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState(24 * 60 * 60); // 24h in seconds
  useEffect(() => {
    const stored = sessionStorage.getItem('countdownEnd');
    let endTime: number;
    if (stored) {
      endTime = parseInt(stored, 10);
    } else {
      endTime = Date.now() + 24 * 60 * 60 * 1000;
      sessionStorage.setItem('countdownEnd', endTime.toString());
    }
    const tick = () => {
      const remaining = Math.max(0, Math.floor((endTime - Date.now()) / 1000));
      setTimeLeft(remaining);
    };
    tick();
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div id="countdown-timer" className="bg-gradient-to-r from-red-600 to-red-700 rounded-xl shadow-lg p-3 md:p-4 mb-4 md:mb-5 scroll-mt-2" data-id="element-0">
      <p className="text-white text-[10px] md:text-xs font-bold uppercase tracking-widest text-center mb-2" data-id="element-1">
        ⏰ Oferta termina en:
      </p>
      <div className="flex items-center justify-center gap-1.5 md:gap-2" data-id="element-2">
        {[{
        label: 'Horas',
        value: hours
      }, {
        label: 'Min',
        value: minutes
      }, {
        label: 'Seg',
        value: seconds
      }].map((unit, i) => <Fragment key={unit.label} data-id="element-3">
            <div className="bg-white rounded-lg px-2.5 md:px-4 py-1.5 md:py-2 min-w-[48px] md:min-w-[64px] shadow-inner" data-id="element-4">
              <div className="text-xl md:text-2xl font-black text-red-600 leading-none tabular-nums text-center" data-id="element-5">
                {pad(unit.value)}
              </div>
              <div className="text-[9px] md:text-[10px] font-bold text-gray-500 uppercase tracking-wide text-center mt-0.5" data-id="element-6">
                {unit.label}
              </div>
            </div>
            {i < 2 && <div className="text-white text-xl md:text-2xl font-black animate-pulse" data-id="element-7">
                :
              </div>}
          </Fragment>)}
      </div>
    </div>;
};
const SocialProofPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  const names = ['María G.', 'Juan P.', 'Laura M.', 'Carlos R.', 'Sofía T.', 'Diego L.', 'Ana C.'];
  const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Salta'];
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 10000);
    // Recurring
    const interval = setInterval(() => {
      showPopup();
    }, 25000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-xl border border-gray-100 animate-in slide-in-from-bottom-5 fade-in duration-500 max-w-sm overflow-hidden" data-id="element-8">
      {/* Green verified banner */}
      <div className="bg-green-600 px-4 py-1.5 flex items-center gap-1.5" data-id="element-9">
        <ShieldCheck className="w-3.5 h-3.5 text-white" data-id="element-10" />
        <span className="text-[10px] font-black text-white uppercase tracking-widest" data-id="element-11">
          Compra verificada
        </span>
      </div>
      <div className="p-4 flex items-start gap-4" data-id="element-12">
        <div className="bg-[#1a4d3a] rounded-full p-2 mt-1" data-id="element-13">
          <Check className="w-4 h-4 text-white" data-id="element-14" />
        </div>
        <div className="flex-1" data-id="element-15">
          <p className="text-sm font-semibold text-gray-900 animate-pulse" data-id="element-16">
            {data.name} de {data.city}
          </p>
          <p className="text-xs text-gray-600 mt-0.5" data-id="element-17">
            Compró KIT Psicología de Adicciones™
          </p>
          <p className="text-[10px] text-gray-400 mt-1" data-id="element-18">Hace unos minutos</p>
        </div>
        <button onClick={() => setIsVisible(false)} className="text-gray-400 hover:text-gray-600" data-id="element-19">
          <X className="w-4 h-4" data-id="element-20" />
        </button>
      </div>
    </div>;
};
export function App() {
  const [selectedOffer, setSelectedOffer] = useState<'base' | 'plus'>('plus');
  const checkoutUrl = selectedOffer === 'plus' ? CHECKOUT_URL_PLUS : CHECKOUT_URL_BASE;
  return <div className="min-h-screen bg-[#faf8f5] text-gray-800 font-sans selection:bg-[#d4af37] selection:text-white" data-id="element-21">
      {/* 1. HERO SECTION */}
      <section className="bg-[#0d3b2e] text-white min-h-screen md:min-h-0 flex flex-col justify-center pt-8 pb-12 md:pt-16 md:pb-20 px-4 md:px-6 relative overflow-hidden" data-id="element-22">
        <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none" style={{
        backgroundImage: 'radial-gradient(circle at 50% 0%, #1a4d3a 0%, transparent 70%)'
      }} data-id="element-23"></div>

        <div className="max-w-5xl mx-auto flex flex-col items-center text-center relative z-10 space-y-3 md:space-y-4" data-id="element-24">
          <div className="inline-block bg-[#1a4d3a] border border-[#d4af37]/30 text-[#d4af37] px-3 py-1 rounded-full text-[11px] md:text-sm font-semibold tracking-wide uppercase" data-id="element-25">
            KIT PSICOLOGÍA DE ADICCIONES™
          </div>
          <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold leading-tight text-white max-w-4xl" data-id="element-26">
            DEJÁ DE IMPROVISAR EN EL TRATAMIENTO DE ADICCIONES
          </h1>

          <div className="relative cursor-pointer group py-1 md:py-2" onClick={scrollToPurchase} data-id="element-27">
            <div className="absolute inset-0 bg-[#d4af37] opacity-20 blur-3xl rounded-full group-hover:opacity-30 transition-opacity duration-500" data-id="element-28"></div>
            <img src={MOCKUP_URL} alt="KIT Psicología de Adicciones" className="relative z-10 w-full max-w-[220px] sm:max-w-[260px] md:max-w-sm mx-auto drop-shadow-2xl transform group-hover:scale-[1.02] transition-transform duration-500" data-id="element-29" />
          </div>

          <p className="text-base sm:text-lg md:text-2xl text-[#c9a96e] font-medium" data-id="element-30">
            Estructurá el abordaje clínico desde la primera consulta.
          </p>
          <p className="text-sm sm:text-base md:text-lg text-gray-300 leading-relaxed max-w-2xl" data-id="element-31">
            El sistema completo para psicólogos que quieren ordenar la
            evaluación, planificación, intervención, seguimiento y cierre del
            tratamiento de pacientes en recuperación de adicciones.
          </p>

          <div className="w-full max-w-md pt-2" data-id="element-32">
            <button onClick={scrollToPurchase} className="w-full bg-[#d4af37] hover:bg-[#c9a96e] text-[#0d3b2e] font-bold text-base md:text-lg px-6 py-3 md:px-8 md:py-4 rounded-lg shadow-[0_4px_14px_0_rgba(212,175,55,0.39)] transition-all duration-300 hover:-translate-y-1 flex items-center justify-center gap-2" data-id="element-33">
              SÍ, QUIERO EL KIT AHORA
              <ArrowRight className="w-5 h-5" data-id="element-34" />
            </button>
            <div className="flex items-center justify-center gap-2 mt-3 text-xs md:text-sm text-gray-400" data-id="element-35">
              <Lock className="w-3.5 h-3.5" data-id="element-36" />
              <span data-id="element-37">Acceso inmediato · Pago único y seguro</span>
            </div>
          </div>
        </div>
      </section>

      {/* 2. INTRO/POSITIONING SECTION */}
      <section className="py-24 px-6 bg-white" data-id="element-38">
        <div className="max-w-5xl mx-auto text-center space-y-16" data-id="element-39">
          <div className="space-y-4 max-w-3xl mx-auto" data-id="element-40">
            <h2 className="text-sm font-bold tracking-widest text-[#d4af37] uppercase" data-id="element-41">
              UN SISTEMA PARA TRABAJAR ADICCIONES CON MÁS ORDEN CLÍNICO
            </h2>
            <h3 className="text-3xl md:text-4xl font-bold text-[#0d3b2e]" data-id="element-42">
              KIT Psicología de Adicciones™
            </h3>
            <p className="text-xl text-gray-600 font-medium" data-id="element-43">
              Sistema completo de tratamiento en 8 etapas
            </p>
            <p className="text-lg text-gray-600 leading-relaxed mt-6" data-id="element-44">
              Creamos un sistema claro y aplicable para que dejes de abordar
              casos de adicciones desde la improvisación, la intuición o la
              urgencia del momento… y empieces a conducir cada proceso con una
              estructura clínica concreta desde la primera consulta hasta el
              alta.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 text-left" data-id="element-45">
            <div className="bg-[#faf8f5] p-8 rounded-2xl border border-gray-100 hover:shadow-lg transition-shadow" data-id="element-46">
              <div className="bg-[#1a4d3a] w-12 h-12 rounded-lg flex items-center justify-center mb-6" data-id="element-47">
                <Compass className="w-6 h-6 text-[#d4af37]" data-id="element-48" />
              </div>
              <h4 className="text-xl font-bold text-[#0d3b2e] mb-3" data-id="element-49">
                MÁS CLARIDAD DESDE EL INICIO
              </h4>
              <p className="text-gray-600" data-id="element-50">
                Sabés qué evaluar, qué preguntar, qué observar y cómo ordenar la
                información clínica del caso.
              </p>
            </div>

            <div className="bg-[#faf8f5] p-8 rounded-2xl border border-gray-100 hover:shadow-lg transition-shadow" data-id="element-51">
              <div className="bg-[#1a4d3a] w-12 h-12 rounded-lg flex items-center justify-center mb-6" data-id="element-52">
                <ShieldCheck className="w-6 h-6 text-[#d4af37]" data-id="element-53" />
              </div>
              <h4 className="text-xl font-bold text-[#0d3b2e] mb-3" data-id="element-54">
                MÁS SEGURIDAD PROFESIONAL
              </h4>
              <p className="text-gray-600" data-id="element-55">
                Tenés protocolos para crisis, recaídas, motivación, familia,
                prevención y cierre del proceso.
              </p>
            </div>

            <div className="bg-[#faf8f5] p-8 rounded-2xl border border-gray-100 hover:shadow-lg transition-shadow" data-id="element-56">
              <div className="bg-[#1a4d3a] w-12 h-12 rounded-lg flex items-center justify-center mb-6" data-id="element-57">
                <LayoutGrid className="w-6 h-6 text-[#d4af37]" data-id="element-58" />
              </div>
              <h4 className="text-xl font-bold text-[#0d3b2e] mb-3" data-id="element-59">
                MÁS ESTRUCTURA EN CADA ETAPA
              </h4>
              <p className="text-gray-600" data-id="element-60">
                No es teoría abstracta. Son guías, plantillas, preguntas y
                recursos prácticos para aplicar en el trabajo clínico real.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 3. QUÉ INCLUYE SECTION */}
      <section className="py-24 px-6 bg-[#faf8f5]" data-id="element-61">
        <div className="max-w-5xl mx-auto space-y-16" data-id="element-62">
          <div className="text-center space-y-6 max-w-3xl mx-auto" data-id="element-63">
            <h2 className="text-3xl md:text-4xl font-bold text-[#0d3b2e]" data-id="element-64">
              QUÉ INCLUYE KIT PSICOLOGÍA DE ADICCIONES
            </h2>
            <p className="text-lg text-gray-600" data-id="element-65">
              Todo lo que necesitás para estructurar el tratamiento de pacientes
              en recuperación de adicciones desde la primera consulta hasta el
              cierre del proceso.
            </p>

            <div className="bg-white p-8 rounded-2xl border border-gray-200 shadow-sm mt-8 text-left" data-id="element-66">
              <h3 className="text-2xl font-bold text-[#0d3b2e] mb-3 flex items-center gap-3" data-id="element-67">
                <Star className="w-6 h-6 text-[#d4af37] fill-[#d4af37]" data-id="element-68" />
                Guía Principal: KIT Psicología de Adicciones
              </h3>
              <p className="text-gray-600 text-lg" data-id="element-69">
                El sistema completo para ordenar el abordaje clínico de
                pacientes con consumo problemático, conductas adictivas o juego
                patológico.
              </p>
            </div>
          </div>

          <div data-id="element-70">
            <h3 className="text-2xl font-bold text-center text-[#0d3b2e] mb-10" data-id="element-71">
              Sistema Psicología de Adicciones™ en 8 etapas
            </h3>

            <div className="grid grid-cols-2 gap-3 md:gap-6" data-id="element-72">
              {[{
              num: '01',
              title: 'Evaluación inicial',
              desc: 'Protocolo de primera consulta con pacientes con adicciones. Anamnesis, historia del consumo, evaluación del nivel de dependencia y motivación para el cambio.'
            }, {
              num: '02',
              title: 'Diagnóstico y conceptualización del caso',
              desc: 'Sistema para formular el caso clínico, identificar factores de riesgo, mantenimiento y protección, y establecer el encuadre terapéutico.'
            }, {
              num: '03',
              title: 'Plan de tratamiento',
              desc: 'Diseño del plan de intervención por objetivos, etapas y técnicas. Adaptado a sustancias y juego patológico.'
            }, {
              num: '04',
              title: 'Intervención en crisis y recaídas',
              desc: 'Protocolo de actuación ante crisis de consumo, recaída y situaciones de alto riesgo. Qué hacer, qué decir y cómo contener sin perder el vínculo terapéutico.'
            }, {
              num: '05',
              title: 'Trabajo motivacional',
              desc: 'Sistema de intervención para sostener y fortalecer la motivación del paciente con adicciones a lo largo del proceso de recuperación.'
            }, {
              num: '06',
              title: 'Entorno familiar y red de apoyo',
              desc: 'Protocolo para trabajar con el entorno del paciente. Cómo involucrar a la familia sin que interfiera negativamente en el proceso.'
            }, {
              num: '07',
              title: 'Seguimiento y prevención de recaídas',
              desc: 'Sistema de monitoreo del progreso, identificación de señales de alerta y estrategias concretas de prevención de recaída.'
            }, {
              num: '08',
              title: 'Alta y cierre del proceso',
              desc: 'Protocolo de cierre terapéutico. Criterios de alta, sesión de cierre, plan de mantenimiento y seguimiento post alta.'
            }].map((etapa, idx) => <div key={idx} className="bg-white p-3 md:p-6 rounded-xl border border-gray-100 shadow-sm flex flex-col md:flex-row gap-2 md:gap-4" data-id="element-73">
                  <div className="text-2xl md:text-3xl font-black text-[#d4af37] opacity-50 font-serif leading-none" data-id="element-74">
                    {etapa.num}
                  </div>
                  <div data-id="element-75">
                    <h4 className="text-sm md:text-lg font-bold text-[#0d3b2e] mb-1 md:mb-2 leading-tight" data-id="element-76">
                      {etapa.title}
                    </h4>
                    <p className="text-gray-600 text-xs md:text-sm leading-relaxed" data-id="element-77">
                      {etapa.desc}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>

          <div className="text-center pt-8" data-id="element-78">
            <button onClick={scrollToPurchase} className="bg-[#0d3b2e] hover:bg-[#1a4d3a] text-white font-bold text-lg px-10 py-4 rounded-lg shadow-lg transition-all duration-300 hover:-translate-y-1 inline-flex items-center gap-2" data-id="element-79">
              SÍ, QUIERO EL KIT AHORA
              <ArrowRight className="w-5 h-5 text-[#d4af37]" data-id="element-80" />
            </button>
          </div>
        </div>
      </section>

      {/* 4. BONUSES SECTION */}
      <section className="py-24 px-6 bg-[#0d3b2e] text-white relative overflow-hidden" data-id="element-81">
        <div className="absolute top-0 right-0 w-64 h-64 bg-[#d4af37] opacity-5 rounded-full blur-3xl" data-id="element-82"></div>
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#d4af37] opacity-5 rounded-full blur-3xl" data-id="element-83"></div>

        <div className="max-w-5xl mx-auto relative z-10" data-id="element-84">
          <div className="text-center space-y-6 mb-16" data-id="element-85">
            <div className="inline-block bg-[#d4af37] text-[#0d3b2e] px-6 py-2 rounded-full text-lg font-bold tracking-wide uppercase animate-pulse-subtle shadow-[0_0_15px_rgba(212,175,55,0.5)]" data-id="element-86">
              ¡GRATIS POR EL DÍA DE HOY!
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-87">
              OFERTA ESPECIAL: BONUS PROFESIONALES
            </h2>
            <p className="text-xl text-[#c9a96e]" data-id="element-88">INCLUIDOS CON TU COMPRA</p>
          </div>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-89">
            {/* Bonus 1 */}
            <div className="bg-white text-gray-800 rounded-2xl p-8 relative shadow-2xl" data-id="element-90">
              <div className="absolute -top-4 -right-4 bg-red-500 text-white text-sm font-bold px-4 py-1 rounded-full shadow-lg transform rotate-3" data-id="element-91">
                ¡Incluido hoy!
              </div>
              <h3 className="text-2xl font-bold text-[#0d3b2e] mb-4 pr-8" data-id="element-92">
                BONUS #1 — Psicoeducación para Pacientes con Adicciones
              </h3>
              <p className="text-gray-600 mb-6 italic" data-id="element-93">
                Documento descargable listo para entregar al paciente en las
                primeras sesiones.
              </p>
              <p className="font-semibold text-gray-800 mb-4" data-id="element-94">
                Incluye material claro y accesible sobre:
              </p>
              <ul className="space-y-3 mb-6" data-id="element-95">
                {['qué es la adicción y cómo funciona el cerebro en ella;', 'etapas del proceso de recuperación y por qué ocurre la recaída;', 'el rol del paciente en su propio proceso.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-96">
                    <CheckCircle2 className="w-5 h-5 text-[#d4af37] shrink-0 mt-0.5" data-id="element-97" />
                    <span className="text-gray-700" data-id="element-98">{item}</span>
                  </li>)}
              </ul>
              <div className="bg-[#faf8f5] p-4 rounded-lg border border-[#d4af37]/30 text-sm text-gray-700" data-id="element-99">
                Para que el psicólogo tenga un recurso profesional listo para
                entregar, sin lenguaje técnico complejo y fácil de comprender
                para el paciente.
              </div>
            </div>

            {/* Bonus 2 */}
            <div className="bg-white text-gray-800 rounded-2xl p-8 relative shadow-2xl" data-id="element-100">
              <div className="absolute -top-4 -right-4 bg-red-500 text-white text-sm font-bold px-4 py-1 rounded-full shadow-lg transform rotate-3" data-id="element-101">
                ¡Incluido hoy!
              </div>
              <h3 className="text-2xl font-bold text-[#0d3b2e] mb-4 pr-8" data-id="element-102">
                BONUS #2 — Banco de Preguntas para Entrevista Motivacional
              </h3>
              <p className="text-gray-600 mb-6 italic" data-id="element-103">
                Documento descargable organizado por etapas, con preguntas
                específicas y listas para usar en sesión.
              </p>
              <p className="font-semibold text-gray-800 mb-4" data-id="element-104">
                Incluye preguntas para:
              </p>
              <ul className="space-y-3 mb-6" data-id="element-105">
                {['apertura, exploración del problema y evaluación de motivación;', 'trabajo con ambivalencia y fortalecimiento del compromiso;', 'abordaje de recaídas sin romper el vínculo terapéutico.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-106">
                    <CheckCircle2 className="w-5 h-5 text-[#d4af37] shrink-0 mt-0.5" data-id="element-107" />
                    <span className="text-gray-700" data-id="element-108">{item}</span>
                  </li>)}
              </ul>
              <div className="bg-[#faf8f5] p-4 rounded-lg border border-[#d4af37]/30 text-sm text-gray-700" data-id="element-109">
                Para que no tengas que improvisar cada pregunta y puedas
                sostener conversaciones clínicas con más dirección, cuidado y
                claridad.
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 5. ESTE KIT ES PARA VOS SI... */}
      <section className="py-24 px-6 bg-white" data-id="element-110">
        <div className="max-w-4xl mx-auto" data-id="element-111">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-[#0d3b2e] mb-12" data-id="element-112">
            ESTE KIT ES PARA VOS SI...
          </h2>
          <div className="bg-[#faf8f5] rounded-2xl p-8 md:p-12 border border-gray-100 shadow-sm" data-id="element-113">
            <ul className="space-y-6" data-id="element-114">
              {['Sos psicólogo/a o terapeuta y trabajás, o querés trabajar, con pacientes con adicciones.', 'Querés saber qué evaluar desde la primera consulta.', 'Te cuesta diseñar un plan de tratamiento claro para estos casos.', 'Querés tener protocolos para crisis, recaídas y situaciones de alto riesgo.', 'Buscás un sistema práctico, profesional y aplicable desde el primer día.'].map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-115">
                  <div className="bg-[#1a4d3a] rounded-full p-1 mt-1 shrink-0" data-id="element-116">
                    <Check className="w-4 h-4 text-white" data-id="element-117" />
                  </div>
                  <span className="text-lg text-gray-700" data-id="element-118">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </section>

      {/* 6. EL RESULTADO */}
      <section className="py-24 px-6 bg-[#faf8f5]" data-id="element-119">
        <div className="max-w-5xl mx-auto" data-id="element-120">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-[#0d3b2e] mb-12" data-id="element-121">
            EL RESULTADO:
          </h2>
          <div className="grid md:grid-cols-2 gap-x-12 gap-y-6" data-id="element-122">
            {['Entrás a la primera consulta con más claridad.', 'Diseñás un plan de tratamiento por objetivos y etapas.', 'Intervenís mejor ante crisis y recaídas.', 'Trabajás la motivación sin caer en juicio ni confrontación improductiva.', 'Cerrás el proceso con criterios de alta y seguimiento post alta.'].map((item, i) => <div key={i} className="flex items-start gap-3 bg-white p-4 rounded-lg border border-gray-100 shadow-sm" data-id="element-123">
                <ArrowRight className="w-5 h-5 text-[#d4af37] shrink-0 mt-0.5" data-id="element-124" />
                <span className="text-gray-700 font-medium" data-id="element-125">{item}</span>
              </div>)}
          </div>
        </div>
      </section>

      {/* 7. PURCHASE SECTION */}
      <section id="comprar" className="py-6 md:py-12 px-4 md:px-6 bg-gradient-to-b from-white to-[#faf8f5] relative" data-id="element-126">
        <div id="purchase-block" className="max-w-2xl w-full mx-auto text-center scroll-mt-2" data-id="element-127">
          <div className="space-y-1 mb-3 md:mb-4" data-id="element-128">
            <h2 className="text-lg md:text-2xl font-bold text-[#0d3b2e] leading-tight" data-id="element-129">
              ESTRUCTURÁ EL TRATAMIENTO DE ADICCIONES
            </h2>
            <p className="text-xs md:text-sm text-gray-600 font-medium" data-id="element-130">
              Un solo pago. Tuyo para siempre.
            </p>
          </div>

          <CountdownTimer data-id="element-131" />

          <div id="oferta-card" className="bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden" data-id="element-132">
            {/* Upsell info banner */}
            <div className="bg-[#fdf6e3] border-b border-[#d4af37]/30 p-3 md:p-4 flex items-start gap-2.5 text-left" data-id="element-133">
              <div className="bg-[#d4af37] rounded-full p-1.5 shrink-0" data-id="element-134">
                <Sparkles className="w-3.5 h-3.5 md:w-4 md:h-4 text-white" data-id="element-135" />
              </div>
              <p className="text-xs md:text-sm text-gray-800 leading-snug" data-id="element-136">
                <span className="font-bold" data-id="element-137">
                  Sumá el libro "Vínculos en Adicciones"
                </span>{' '}
                y trabajá lo que más sostiene o sabotea la recuperación:
                familia, pareja y red de apoyo.
              </p>
            </div>

            {/* Mockup */}
            <div className="bg-gray-50 py-4 md:py-5 flex items-center justify-center" data-id="element-138">
              <img src={selectedOffer === 'plus' ? MOCKUP_UPSELL_URL : MOCKUP_URL} alt="KIT Psicología de Adicciones" className="h-32 md:h-40 w-auto object-contain drop-shadow-lg transition-all duration-300" data-id="element-139" />
            </div>

            <div className="p-3 md:p-5 space-y-3" data-id="element-140">
              {/* OPTIONS */}
              <div className="space-y-2" data-id="element-141">
                {/* Option 1 — Base */}
                <button type="button" onClick={() => setSelectedOffer('base')} className={`w-full flex items-center gap-3 p-3 md:p-4 rounded-xl border-2 transition-all duration-200 text-left ${selectedOffer === 'base' ? 'border-[#d4af37] bg-[#fdf6e3]/40' : 'border-gray-200 bg-white hover:border-gray-300'}`} data-id="element-142">
                  <div className={`w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center shrink-0 transition-all ${selectedOffer === 'base' ? 'border-[#d4af37] bg-[#d4af37]' : 'border-gray-300 bg-white'}`} data-id="element-143">
                    {selectedOffer === 'base' && <Check className="w-3 h-3 md:w-4 md:h-4 text-white" strokeWidth={3} data-id="element-144" />}
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-145">
                    <p className="text-xs md:text-sm font-bold text-[#0d3b2e] uppercase tracking-wide leading-tight" data-id="element-146">
                      KIT Psicología de Adicciones
                    </p>
                  </div>
                  <div className="text-right shrink-0" data-id="element-147">
                    <div className="text-[10px] md:text-xs text-gray-400 line-through font-semibold leading-none" data-id="element-148">
                      $49.990
                    </div>
                    <div className="text-base md:text-lg font-black text-[#0d3b2e] leading-tight" data-id="element-149">
                      $19.990
                    </div>
                  </div>
                </button>

                {/* Option 2 — Plus */}
                <button type="button" onClick={() => setSelectedOffer('plus')} className={`relative w-full flex items-center gap-3 p-3 md:p-4 rounded-xl border-2 transition-all duration-200 text-left ${selectedOffer === 'plus' ? 'border-[#d4af37] bg-[#fdf6e3]/40' : 'border-gray-200 bg-white hover:border-gray-300'}`} data-id="element-150">
                  <span className="absolute -top-2.5 right-3 bg-[#d4af37] text-[#0d3b2e] text-[9px] md:text-[10px] font-black px-2 py-0.5 rounded-full shadow-md flex items-center gap-1 whitespace-nowrap" data-id="element-151">
                    <Crown className="w-2.5 h-2.5 md:w-3 md:h-3" fill="currentColor" data-id="element-152" />
                    MÁS ELEGIDA
                  </span>
                  <div className={`w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center shrink-0 transition-all ${selectedOffer === 'plus' ? 'border-[#d4af37] bg-[#d4af37]' : 'border-gray-300 bg-white'}`} data-id="element-153">
                    {selectedOffer === 'plus' && <Check className="w-3 h-3 md:w-4 md:h-4 text-white" strokeWidth={3} data-id="element-154" />}
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-155">
                    <p className="text-xs md:text-sm font-bold text-[#0d3b2e] uppercase tracking-wide leading-tight" data-id="element-156">
                      KIT + Vínculos en Adicciones
                    </p>
                  </div>
                  <div className="text-right shrink-0" data-id="element-157">
                    <div className="text-[10px] md:text-xs text-gray-400 line-through font-semibold leading-none" data-id="element-158">
                      $69.990
                    </div>
                    <div className="text-base md:text-lg font-black text-[#0d3b2e] leading-tight" data-id="element-159">
                      $29.990
                    </div>
                  </div>
                </button>
              </div>

              {/* INCLUDES */}
              <div className="bg-gray-50 rounded-xl p-3 md:p-4 text-left" data-id="element-160">
                <p className="text-[10px] md:text-xs font-black text-gray-600 uppercase tracking-widest mb-2" data-id="element-161">
                  Incluye:
                </p>
                <ul className="space-y-1.5" data-id="element-162">
                  {(selectedOffer === 'plus' ? [{
                  text: 'Todo lo del KIT Psicología de Adicciones',
                  highlight: false
                }, {
                  text: 'Libro: Vínculos en Adicciones',
                  highlight: true
                }, {
                  text: 'Intervención con familia y pareja',
                  highlight: false
                }, {
                  text: 'BONUS: Psicoeducación para Pacientes',
                  highlight: true
                }, {
                  text: 'BONUS: Banco de Preguntas Motivacional',
                  highlight: true
                }] : [{
                  text: 'Guía Principal Completa',
                  highlight: false
                }, {
                  text: 'Sistema Psicología de Adicciones™ en 8 etapas',
                  highlight: false
                }, {
                  text: 'Plantillas y protocolos clínicos',
                  highlight: false
                }, {
                  text: 'BONUS: Psicoeducación para Pacientes',
                  highlight: true
                }, {
                  text: 'BONUS: Banco de Preguntas Motivacional',
                  highlight: true
                }]).map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-163">
                      <Check className={`w-3.5 h-3.5 md:w-4 md:h-4 shrink-0 mt-0.5 ${item.highlight ? 'text-[#d4af37]' : 'text-[#1a4d3a]'}`} strokeWidth={3} data-id="element-164" />
                      <span className={`text-xs md:text-sm leading-tight ${item.highlight ? 'text-[#d4af37] font-bold' : 'text-gray-700'}`} data-id="element-165">
                        {item.text}
                      </span>
                    </li>)}
                </ul>
              </div>

              {/* PRICE + CTA BOX */}
              <div className="bg-[#0d3b2e] rounded-xl p-4 md:p-5 space-y-3" data-id="element-166">
                <div className="flex items-baseline justify-center gap-2 md:gap-3" data-id="element-167">
                  <span className="text-base md:text-lg text-gray-400 line-through font-bold" data-id="element-168">
                    {selectedOffer === 'plus' ? '$69.990' : '$49.990'}
                  </span>
                  <span className="text-3xl md:text-4xl font-black text-white leading-none" data-id="element-169">
                    {selectedOffer === 'plus' ? '$29.990' : '$19.990'}
                  </span>
                  <span className="text-xs md:text-sm text-gray-400 font-semibold" data-id="element-170">
                    ARS
                  </span>
                </div>

                <a href={checkoutUrl} className="block w-full bg-[#d4af37] hover:bg-[#c9a96e] text-[#0d3b2e] font-black text-sm md:text-lg px-4 py-3 md:py-4 rounded-lg shadow-[0_4px_20px_0_rgba(212,175,55,0.4)] transition-all duration-300 hover:-translate-y-0.5 text-center uppercase tracking-wide" data-id="element-171">
                  SÍ, QUIERO EL KIT AHORA
                </a>

                <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[10px] md:text-xs text-gray-300 font-medium" data-id="element-172">
                  <span className="flex items-center gap-1" data-id="element-173">
                    <Check className="w-3 h-3 text-[#d4af37]" strokeWidth={3} data-id="element-174" />
                    Pago único
                  </span>
                  <span className="flex items-center gap-1" data-id="element-175">
                    <Check className="w-3 h-3 text-[#d4af37]" strokeWidth={3} data-id="element-176" />
                    Acceso inmediato
                  </span>
                  <span className="flex items-center gap-1" data-id="element-177">
                    <Check className="w-3 h-3 text-[#d4af37]" strokeWidth={3} data-id="element-178" />
                    Garantía 7 días
                  </span>
                </div>

                <div className="flex items-center justify-center gap-1.5 text-[10px] md:text-xs text-[#d4af37] font-bold" data-id="element-179">
                  <Star className="w-3 h-3 md:w-3.5 md:h-3.5 fill-[#d4af37]" data-id="element-180" />
                  +500 profesionales
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 8. FOOTER */}
      <footer className="bg-[#0d3b2e] text-gray-400 py-12 px-6 text-center text-sm" data-id="element-181">
        <div className="max-w-4xl mx-auto space-y-6" data-id="element-182">
          <p data-id="element-183">
            © 2026 KIT Psicología de Adicciones. Todos los derechos reservados.
          </p>
          <p className="text-xs opacity-60 max-w-2xl mx-auto leading-relaxed" data-id="element-184">
            Este sitio no es parte del sitio web de Facebook o Meta Inc. Además,
            este sitio NO está respaldado por Facebook de ninguna manera.
          </p>
        </div>
      </footer>

      <SocialProofPopup data-id="element-185" />
    </div>;
}